import { useAuth } from './useAuth';

/**
 * The two read-only accounts: 'viewer' browses the admin app, 'crew_viewer'
 * browses the crew app. `server/middleware/auth.js` refuses every non-GET they
 * send, so a control that still looks live is a lie — it can only ever produce
 * a 403. Use this to grey the control out and say why.
 */
export function useReadOnly(): boolean {
  const { user } = useAuth();
  return user?.role === 'viewer' || user?.role === 'crew_viewer';
}
